/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IChatUser1 {
  /** Роль пользователя в чате, в котором он передан **/
  chatRole: TChatUser1_ChatRole;
  /**
   *
   *         Пользователь имеет опубликованный профиль в каталоге специалистов.
   *         Флаг нужен для понимания того, возможен ли переход к просмотру профиля.
   *         Поле можно будет удалить после переезда на профиль собеседника в чате.
   *         Переход в профиль из каталога будет осуществляться оттуда.
   *
   */
  hasPublicProfile: boolean;
  /** Доступен ли пользователь для звонка. Раньше поле находилось в data.agent структуре **/
  isAvailableForPhoneCall: boolean;
  /** Идентификатор пользователя (realty_user_id) **/
  userId: number;
  /** Название компании. На Android НЕ используется. **/
  agencyName?: TChatUser1_AgencyName;
  /** Тип пользователя. На Android НЕ используется. **/
  agentAccountType?: TChatUser1_AgentAccountType;
  /**
   *
   *         Ссылка на аватарку. Используется в списке чатов на месте фото в случае,
   *         если чат инициирован с агентом, а не по объявлению.
   *
   */
  agentAvatarUrl?: TChatUser1_AgentAvatarUrl;
  /**
   *
   *         Имя пользователя в соответствии с требованиями бизнеса.
   *         Если отсутствует, то клиенты отображают Идентификатор пользователя по своей логике.
   *
   */
  name?: TChatUser1_Name;
  /** Ссылка на изображение, которая должна использоваться вместо имени пользователя на клиентах **/
  nameReplacementImageUrl?: TChatUser1_NameReplacementImageUrl;
  /** Телефоны для контакта с пользователем, в формате 79133451133 **/
  phones?: TChatUser1_Phones;
  /** Абсолютный URL на публичный профиль агента **/
  urlToAgentPublicProfile?: TChatUser1_UrlToAgentPublicProfile;
}

export type TChatUser1_ChatRole = EChatRole | string;

export enum EChatRole {
  /**
   *
   *     Клиент, который проявил интерес к бизнес-предложению (откликнулся по объявлению, оставил заявку)
   *
   */
  'Initiator' = 'initiator',
  /**
   *
   *     Тот, кто реагирует на интерес initiator (публикует объявление, получает заявку)
   *
   */
  'Opponent' = 'opponent',
  /**
   *
   *     В случае агентств недвижимости — руководитель opponent (может добавиться в чат, где уже есть initiator и opponent)
   *
   */
  'Master' = 'master',
  /**
   *
   *     Все остальные возможные участники чата (в том числе чат-боты)
   *
   */
  'Companion' = 'companion',
}
export type TChatUser1_AgencyName = null | string;

export type TChatUser1_AgentAccountType = EAgentAccountType | string | null;

export enum EAgentAccountType {
  /** Специалист **/
  'Agency' = 'agency',
  /** Собственник **/
  'Homeowner' = 'homeowner',
  /** Застройщик **/
  'Developer' = 'developer',
  /** Риэлтор **/
  'Specialist' = 'specialist',
  /** Поискун **/
  'Searcher' = 'searcher',
  /** Системные сообщения от администрации ЦИАН-а **/
  'System' = 'system',
  /** Управляющая компания **/
  'Management_company' = 'management_company',
  /** Отдел аренды **/
  'Rent_department' = 'rent_department',
}
export type TChatUser1_AgentAvatarUrl = null | string;

export type TChatUser1_Name = null | string;

export type TChatUser1_NameReplacementImageUrl = null | string;

export type TChatUser1_Phones = null | string[];

export type TChatUser1_UrlToAgentPublicProfile = null | string;
